// extracted by mini-css-extract-plugin
module.exports = {"spinner":"PunchupSpinner_spinner__Naqie","punchupSpinnerRotate":"PunchupSpinner_punchupSpinnerRotate__NBj7n","spinnerCurrent":"PunchupSpinner_spinnerCurrent__AwTT3"};